import React from "react";

interface ExitIconProps {
  fill?: string;
}

const ExitIcon: React.FC<ExitIconProps> = ({ fill = "#00132E" }) => (
  <svg
    // width="344"
    // height="384"
    viewBox="0 0 344 384"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M171.98 383.44C160.28 383.44 148.58 380.37 138.15 374.22L32.82 312.17C12.57 300.22 0 278.22 0 254.73V128.7C0 128.42 0 128.16 0.01 127.89C0.28 104.74 12.83 83.0601 32.81 71.2801L138.15 9.22012C159.02 -3.07988 184.94 -3.07988 205.81 9.22012L311.15 71.2701C331.39 83.1901 343.97 105.2 343.97 128.7V254.73C343.97 278.22 331.4 300.22 311.16 312.16L205.81 374.21C195.38 380.36 183.68 383.43 171.98 383.43V383.44ZM24 128.72V254.74C24 269.77 32.05 283.85 45.01 291.49L150.34 353.54C163.69 361.41 180.28 361.41 193.64 353.54L298.98 291.49C311.93 283.85 319.98 269.77 319.98 254.74V128.71C319.98 113.67 311.93 99.5901 298.98 91.9601L193.64 29.9101C180.29 22.0401 163.7 22.0401 150.34 29.9101L45.01 91.9601C32.19 99.5201 24.14 113.45 24.02 128.31V128.72H24Z"
      fill={fill}
    />
    <path
      d="M331.97 128.7V254.73C331.97 274.09 321.73 291.99 305.06 301.82L260.76 327.92L231.96 344.88L158.87 301.82C142.19 291.99 131.95 274.09 131.95 254.73V128.7C131.95 128.53 131.95 128.37 131.97 128.2C132.12 109.03 142.33 91.3601 158.87 81.6101L231.96 38.55L305.06 81.6101C321.73 91.43 331.97 109.34 331.97 128.7Z"
      fill={fill}
    />
    <path
      d="M185.79 196.37V187.06C185.79 185.72 185.08 184.49 183.92 183.82L175.86 179.16C174.7 178.49 173.28 178.49 172.12 179.16L164.06 183.82C162.9 184.49 162.19 185.72 162.19 187.06V196.37C162.19 197.71 162.9 198.94 164.06 199.61L172.12 204.27C173.28 204.94 174.7 204.94 175.86 204.27L183.92 199.61C185.08 198.94 185.79 197.71 185.79 196.37Z"
      fill="#FFFFFF"
    />
  </svg>
);

export default ExitIcon;
